import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../contexts/CartContext';
const drinks = [{
  id: 'drink-1',
  name: 'Drinks',
  desc: 'Assorted beverages available. Ask for our current selection.',
  price: '$0.01',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/08/Drinks-Latest.jpeg?fit=1024%2C768&ssl=1',
  emoji: '🥤'
}];
interface DrinksPageProps {
  onNavigate: (page: string) => void;
}
export function DrinksPage({
  onNavigate
}: DrinksPageProps) {
  const {
    addToCart
  } = useCart();
  const [addedId, setAddedId] = useState<string | null>(null);
  const handleAdd = (item: any) => {
    addToCart({
      id: item.id,
      name: item.name,
      price: parseFloat(item.price.replace('$', '')),
      emoji: item.emoji,
      image: item.image
    });
    setAddedId(item.id);
    setTimeout(() => setAddedId(null), 1200);
  };
  const drinkItem = drinks[0];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen bg-cream pb-20" data-id="element-532">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-533">
        <button onClick={() => onNavigate('menu')} className="mb-8 font-heading text-charcoal/60 hover:text-charcoal uppercase tracking-wider transition-colors" data-id="element-534">
          ← Back to Full Menu
        </button>

        <h1 className="font-heading text-5xl md:text-6xl text-charcoal uppercase tracking-wide mb-4 text-center" data-id="element-535">
          Drinks & <span className="text-blue-600" data-id="element-536">Beverages</span>
        </h1>
        <p className="text-center font-body text-charcoal/70 max-w-2xl mx-auto mb-12" data-id="element-537">
          Authentic refreshments to complement your meal.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border border-amber/10 flex flex-col md:flex-row gap-8 items-center" data-id="element-538">
          <div className="w-full md:w-1/2 h-64 md:h-96 bg-cream rounded-2xl overflow-hidden shadow-inner" data-id="element-539">
            {drinkItem.image ? <img src={drinkItem.image} alt={drinkItem.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-540" /> : <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-400 to-indigo-500" data-id="element-541">
                <span className="text-7xl drop-shadow-md" data-id="element-542">
                  {drinkItem.emoji}
                </span>
              </div>}
          </div>

          <div className="w-full md:w-1/2 flex flex-col" data-id="element-543">
            <h3 className="font-heading text-4xl uppercase text-charcoal mb-4" data-id="element-544">
              {drinkItem.name}
            </h3>
            <p className="font-body text-charcoal/70 text-lg mb-8 leading-relaxed" data-id="element-545">
              {drinkItem.desc}
            </p>

            <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-8" data-id="element-546">
              <p className="font-body text-blue-800 text-sm flex items-center" data-id="element-547">
                <span className="mr-2" data-id="element-548">ℹ️</span>
                Prices vary based on selection. Add to order to request specific
                drinks upon pickup/delivery.
              </p>
            </div>

            <div className="flex justify-between items-center mt-auto pt-6 border-t border-charcoal/10" data-id="element-549">
              <span className="font-heading text-4xl text-victory-red" data-id="element-550">
                Varies
              </span>
              <button onClick={() => handleAdd(drinkItem)} className={`px-8 py-4 rounded-xl font-heading uppercase tracking-wider text-lg transition-colors active:scale-95 shadow-md ${addedId === drinkItem.id ? 'bg-green-600 text-white' : 'bg-charcoal text-white hover:bg-amber'}`} data-id="element-551">
                {addedId === drinkItem.id ? 'Added ✓' : 'Add to Order'}
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}